/* Via dei Mille — comportamenti dell'intestazione.
   Il pannello mobile e' nascosto con [hidden], non con una transizione:
   chiuso e' inerte per la tastiera e per i lettori di schermo. */

class VdmHeader extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('[data-vdm-menu]');
    this.apri = this.querySelector('[data-vdm-apri-menu]');
    this.chiudi = this.querySelector('[data-vdm-chiudi-menu]');
    this.onTasto = this.onTasto.bind(this);
  }

  connectedCallback() {
    if (!this.menu || !this.apri) return;
    this.apri.addEventListener('click', () => this.mostra());
    if (this.chiudi) this.chiudi.addEventListener('click', () => this.nascondi());
    // Una voce toccata deve chiudere il pannello, non lasciarlo aperto sotto.
    this.menu.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => this.nascondi({ ripristinaFuoco: false }));
    });
  }

  mostra() {
    this.menu.hidden = false;
    this.menu.setAttribute('data-vdm-animato', '');
    this.apri.setAttribute('aria-expanded', 'true');
    this.bloccaScorrimento(true);
    document.addEventListener('keydown', this.onTasto);
    const primo = this.chiudi || this.menu.querySelector('a');
    if (primo) primo.focus();
  }

  nascondi({ ripristinaFuoco = true } = {}) {
    this.menu.hidden = true;
    this.menu.removeAttribute('data-vdm-animato');
    this.apri.setAttribute('aria-expanded', 'false');
    this.bloccaScorrimento(false);
    document.removeEventListener('keydown', this.onTasto);
    if (ripristinaFuoco) this.apri.focus();
  }

  onTasto(evento) {
    if (evento.key === 'Escape') {
      evento.preventDefault();
      this.nascondi();
      return;
    }
    if (evento.key !== 'Tab') return;

    // Il fuoco resta dentro al pannello finche' e' aperto.
    const raggiungibili = this.menu.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!raggiungibili.length) return;
    const primo = raggiungibili[0];
    const ultimo = raggiungibili[raggiungibili.length - 1];

    if (evento.shiftKey && document.activeElement === primo) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primo.focus();
    }
  }

  bloccaScorrimento(attivo) {
    document.documentElement.style.overflow = attivo ? 'hidden' : '';
  }
}

if (!customElements.get('vdm-header')) {
  customElements.define('vdm-header', VdmHeader);
}
